import { render, staticRenderFns } from "./StatementsList.vue?vue&type=template&id=58c595f5&scoped=true&"
import script from "./StatementsList.vue?vue&type=script&lang=ts&"
export * from "./StatementsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c595f5",
  null
  
)

export default component.exports